import AContainer from '../../library/ExtendedObjects/AContainer.js';

export default class Preloader_Sun extends AContainer
{
    constructor(scene, onClick)
    {
        super(scene);

        this.config = {
            numSunAuras: 2,
            sunAuraSpeed: 2,
            maxAlpha: .7,
            startScale: .67,
            maxAuraScale: .95,
            minAuraScale: .85
        };

        this.percentComplete = 0;
        this.sunRays = [];
        for(let i = 0; i < this.config.numSunAuras; i++)
        {
            let sunAura = this.createSunAura();
            this.tweenAura(sunAura, i * (this.config.sunAuraSpeed / this.config.numSunAuras) * 1000);
        }

        this.mainImage = this.create(0, 0, 'Preloader_Sun.png', 'preloader');
        this.percentageText = this.scene.add.bitmapText(0, 0, 'preloader_font').setOrigin(.5);
        this.percentageText.text = "0%";
        this.add(this.percentageText);

        this.setScale(0);
        this.alpha = 0;
        this.scene.addTween(this, 1000, {alpha: 1}, Phaser.Math.Easing.Linear);
        this.scene.addTween(this, 1000, {scaleX: 1, scaleY: 1}, Phaser.Math.Easing.Back.Out);

        this.playbutton = this.scene.addButton(4, 0, 'Preloader_PlayButton.png', onClick, this, 'preloader');
        this.playbutton.setScale(0);
        this.playbutton.alpha = 0;
    }

    tweenAura(sunAura, delay = 0)
    {
        let min = this.config.minAuraScale;
        let max = this.config.maxAuraScale;
        let scale = (max - min)*this.percentComplete + min;

        sunAura.alpha = this.config.maxAlpha;
        sunAura.setScale(this.config.startScale);

        this.scene.addTween(sunAura, this.config.sunAuraSpeed * 1000, {alpha: 0, scaleY: scale, 
            scaleX: scale, delay: delay}, Phaser.Math.Easing.Quadratic, ()=>{this.tweenAura(sunAura);});
    }

    createSunAura()
    {
        let sunAura = this.scene.addCirc(0, 0, 150, 0xf9db62);
        this.add(sunAura);

        sunAura.setScale(this.config.startScale);
        sunAura.alpha = 1;

        this.sunRays.push(sunAura);
        return sunAura;
    }

    setProgress(progress)
    {
        this.percentageText.text = Math.round(progress * 100) + '%';
        this.percentComplete = progress;
    }

    enablePlayButton()
    {
        this.playbutton.setScale(1.5);
        this.scene.addTween(this.percentageText, 200, { scaleX: 0, scaleY: 0 });
        this.scene.addTween(this.playbutton, 4000, { scaleX: .7, scaleY: .7 }, Phaser.Math.Easing.Elastic.Out);
        this.scene.addTween(this.playbutton, 200, { alpha: 1 });

        this.scene.addTween(this.playbutton, 300, { scaleX: 1, scaleY: 1, delay: 4000}, Phaser.Math.Easing.Linear, ()=>{
            this.scene.addTween(this.playbutton, 4000, { scaleX: .7, scaleY: .7 }, Phaser.Math.Easing.Elastic.Out);
        });
    }
}